import defaultsDeep from 'lodash/defaultsDeep'

import { resolvers as subscriptionResolvers } from './subscriptions'

export default defaultsDeep({}, subscriptionResolvers)
